<template>
    <div>
        <div class="panel panel-default">
            <div class="panel-body">
                <div class="col-md-12">

                    <div class="col-md-12">
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                Targets Information
                            </div>
                            <div class="panel-body" v-if="!fetchTargetsInformationLoading">
                                <div v-for="information in targetsInformation" class="col-md-6">
                                    <div class="panel panel-info">
                                        <div class="panel-heading">
                                            {{ information.title}}
                                        </div>
                                        <div class="panel-body bg-gray" style="display: flex; justify-content: center; align-items: center; font-weight: bold;" v-if="!isIterable(information.value)">
                                            <span style='background: blue; font-size: 32px' class='badge'>
                                                {{ information.value }}
                                            </span>
                                        </div>
                                        <div v-else>
                                            <table class="table table-hover">
                                                <tbody>
                                                    <tr v-for="(value, title) in information.value">
                                                        <td>{{ title }} </td>
                                                        <td>
                                                            <span style='background: blue; font-size: 32px' class='badge'>
                                                                {{ value }}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="panel-body">
                                <div class="loader" id="loader-1"></div>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-12">
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                Report Summary
                            </div>
                            <div class="panel-body" v-if="!fetchReportSummaryLoading">
                                <div class="col-md-2" v-for="(report, index) in summaryReports">
                                    <TrafficInfoPanel
                                        :key="index"
                                        :title="report.label"
                                        v-if="report.target_daily_simulated && report.daily_simulated_left"
                                        :goal="Number(report.target_daily_simulated)"
                                        :left="Number(report.daily_simulated_left)"
                                    />
                                </div>
                            </div>
                            <div v-else class="panel-body">
                                <div class="loader" id="loader-1"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import VueDateFilter from "../../generic/VueDateFilter";
import IframeTargetFilter from "./Filter/IframeTargetFilter";
import PixelTargetFilter from "./Filter/PixelTargetFilter";
import LineChart from "../../admin/charts/LineChart";
import TrafficInfoPanel from "./Panel/TrafficInfoPanel";

const DATE_FORMAT = 'DD/MM/YYYY HH:mm';

export default {
    name: "InsightWidget",
    components: {
        TrafficInfoPanel,
        LineChart,
        PixelTargetFilter,
        IframeTargetFilter,
        VueDateFilter,
    },
    data() {
        return {
            filter: {
                start_at: null,
                end_at: null
            },
            fetchReportSummaryLoading: false,
            fetchTargetsInformationLoading: false,
            summaryReports: [],
            targetsInformation: [],
        }
    },
    mounted() {
        this.fetchReportSummary();
        this.fetchTargetsInformation();
    },
    methods: {
        dateFilterChange(dateFromTimestamp, dateToTimestamp) {
            console.log(dateFromTimestamp, dateToTimestamp);
            this.$set(this.filter, 'start_at', this.parseTime(dateFromTimestamp * 1000));
            this.$set(this.filter, 'end_at', this.parseTime(dateToTimestamp * 1000));

            this.fetch();
        },

        fetchTargetsInformation() {
            this.fetchTargetsInformation = true;
            axios.get('api/insights/targets')
                .then((response) => {
                    this.targetsInformation = response.data;
                    this.fetchTargetsInformation = false;
                }).catch(({response}) => {
                    this.fetchTargetsInformation = false;
            })
        },

        fetchReportSummary() {
            this.fetchReportSummaryLoading = true;
            axios.get('api/insights/traffic/summary')
                .then((response) => {
                    this.summaryReports = response.data;
                    this.fetchReportSummaryLoading = false;
                }).catch(({response}) => {
                    this.fetchReportSummaryLoading = false;
            })
        },

        fetch() {
            axios.post('api/insights/graph', this.filter).then((res) => {
                console.log(res)
            }).catch(({response}) => {

                console.log('err')
                console.log(response);
            })
        },



        handleFiltered(filter)
        {
            this.filter = {...this.filter, ...filter}
            this.fetch();
        },

        isIterable(value)  {
            return typeof value === 'object'
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../../../../sass/admin-panel/partials/_loader.scss";
</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/widgets/InsightWidget/InsightWidget.vue